import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type {
  EndNativeCallPayload,
  NativeCallAcceptedPayload,
  NativeCallDeclinedPayload,
  NativeCallDisplayedPayload,
  NativeCallIOSState,
} from './types'
import { logger } from 'APP/Lib/Datadog'

const initialState: NativeCallIOSState = {
  callerName: '',
  sessionId: '',
  callUUID: '',
  accepted: false,
  declined: false,
}

const { actions, reducer } = createSlice({
  name: 'nativecallios',
  initialState,
  reducers: {
    nativeCallAccepted: (state, action: PayloadAction<NativeCallAcceptedPayload>) => {
      const { callUUID } = action.payload
      logger.info('Updating NativeCallIOSState with accepted from nativeCallAccepted action', {
        callUUID,
      })
      state.accepted = true
    },
    nativeCallDeclined: (state, action: PayloadAction<NativeCallDeclinedPayload>) => {
      const { callUUID } = action.payload
      logger.info('Updating NativeCallIOSState with declined from nativeCallDeclined action', {
        callUUID,
      })
      state.declined = true
    },
    nativeCallDisplayed: (state, action: PayloadAction<NativeCallDisplayedPayload>) => {
      const { sessionId, callUUID } = action.payload

      logger.info('Updating NativeCallIOSState from native call notification', {
        sessionId,
        callUUID,
      })
      state.sessionId = sessionId
      state.callUUID = callUUID
    },
    callAccepted: () => {},
    endNativeCall: (_state, _action: PayloadAction<EndNativeCallPayload>) => {},
    resetState: () => initialState,
  },
})

export { actions as nativeCallIOSActions, initialState }

export default reducer
